import {combineReducers} from 'redux'
import { routerReducer } from 'react-router-redux'
import site from './site'
import account from './account'
import data from './data'
import ui from './ui'
import { nprogress } from 'redux-nprogress';

export default (asyncReducers) => {
    return combineReducers({
        router: routerReducer,
        site,
        account,
        nprogress,
        ui,
        data,
        ...asyncReducers,
    });
}


// WEBPACK FOOTER //
// ./src/reducers/index.js